import { apiClient } from 'pobble-components/dist/api'
import { Modal, ModalContent, ModalFooter } from 'pobble-components/dist/modal'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import ButtonElement from 'pobble-components/dist/button-element'
import injectSheet from 'react-jss/lib/injectSheet'
import { Link } from 'react-router-dom'
import Spinner from 'pobble-components/dist/spinner'
import NoItemsPlaceholder from 'pobble-components/dist/no-items-placeholder'
import Button from 'pobble-components/dist/button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import FormSelect from 'pobble-components/dist/form-elements/form-select'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import { useSubscriptionDetails } from 'pobble-components/dist/subscriptions/utils'
import { SubsCrown } from 'pobble-components/dist/subscriptions'
import { UpsellModal } from '../../../pages/prompt/upsell'
import { Presentation } from 'pobble-components/dist/presentation'
import { useDispatch, useSelector } from 'react-redux'
import { getCreateSlideRequest } from '../../../../stores/presentation/presentation.selectors'
import { getCreateSlideDialog } from '../../../pages/lesson/builder/redux/builder.selectors'
import { createSlide } from '../../../../stores/presentation/presentation.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { closeCreateSlideDialog } from '../../../pages/lesson/builder/redux/builder.actions'

/**
 * Work preview creates a fake presentation
 * that looks like the work asset.
 *
 * We are doing that because if user saves or uses this work
 *  that's what backend will do. It will map the work data
 *  to the presentation asset data.
 *
 * This way we ensure that visual end result is as close
 *  to reality as possible
 *
 */
const WorkPreview = injectSheet({
  content: {
    background: 'var(--light-gray-)',
    overflow: 'hidden',
    maxWidth: '1100px',
    padding: '48px',
    borderRadius: '4px 4px 0 0'
  },
  presentation: {
    boxShadow: '0 0 0 1px rgb(0 0 0 / 16%)',
    borderRadius: '4px',
    overflow: 'hidden',
    '& a': {
      display: 'none !important'
    }
  }
})(({ work, classes, requestClose }) => {
  const dispatch = useDispatch()

  const addWorkSlide = work => {
    dispatch(
      createSlide({
        type: 'Exemplar',
        work_id: work.id,
        title: work.title,
        description: work.description
      })
    ).catch(errorHandler)
  }

  return (
    <>
      <ModalContent className={classes.content}>
        <div className={classes.presentation}>
          <Presentation
            data={{
              id: 'fake_work_presentation',
              accessibility_color: 'none',
              title: work.title,
              category: 'works',
              font_size: 'small',
              font_type: 'default',
              lesson_overview: '',
              asset: true,
              slides: [
                { id: 0 },
                { id: 1 },
                {
                  id: 2,
                  title: work.title,
                  type: 'Exemplar',
                  html_description: `<p>${work.description || ''}<p>`,
                  work: {
                    id: work.id,
                    title: 'title',
                    media: work.media
                  }
                }
              ]
            }}
          />
        </div>
      </ModalContent>
      <ModalFooter alignRight childrenGap>
        <Button tall tertiary action={requestClose}>
          Close
        </Button>
        <Button
          tall
          action={() => {
            requestClose()
            addWorkSlide(work)
          }}>
          Add this slide
        </Button>
      </ModalFooter>
    </>
  )
})

const WorkPreviewModal = ({ isOpen, requestClose, work }) => {
  return (
    <Modal isOpen={isOpen} requestClose={requestClose} closeButton>
      <WorkPreview work={work} requestClose={requestClose} />
    </Modal>
  )
}

const Img = injectSheet({
  img: {
    transform: 'translateY(8px)',
    opacity: '0'
  },
  loaded: {
    opacity: '1',
    transform: 'translateY(0)'
  }
})(({ classes, className, alt, ...props }) => {
  const [loaded, setLoaded] = useState(false)
  return (
    <img
      alt={alt}
      className={`${classes.img} ${className} ${loaded ? classes.loaded : ''}`}
      onLoad={() => setLoaded(true)}
      {...props}
    />
  )
})

const WorksGrid = injectSheet({
  works: {
    padding: '64px 0 0 0',
    display: 'grid',
    gap: '80px 24px',
    gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
    '& img': {
      position: 'absolute',
      bottom: '96px',
      left: '16px',
      width: 'calc(100% - 32px)',
      maxHeight: '270px',
      boxShadow: '0 0 4px rgba(0, 0, 0, .2)',
      objectFit: 'cover',
      objectPosition: 'top',
      transition: 'transform .2s ease-out, opacity .2s ease-out'
    }
  },
  work: {
    height: '320px',
    borderRadius: '8px',
    background: 'var(--gray-)',
    padding: '16px',
    position: 'relative',
    boxShadow: '0 0 4px rgba(0, 0, 0, .2)',
    '&:hover': {
      '& img': {
        transform: 'translateY(-8px)'
      }
    },
    '& footer': {
      position: 'absolute',
      left: '0',
      bottom: '0',
      background: '#fff',
      width: '100%',
      borderRadius: '0 0 8px 8px',
      color: 'var(--gray)',
      zIndex: '10',
      '&:after': {
        content: '""',
        position: 'absolute',
        left: '0',
        width: '100%',
        bottom: '100%',
        background:
          'linear-gradient(to top, rgba(0, 0, 0, .2), rgba(0, 0, 0, 0))',
        height: '16px',
        zIndex: '10'
      },
      '& h3': {
        font: 'var(--heading---)',
        textAlign: 'center',
        margin: '0',
        padding: '16px'
      }
    }
  },
  holder: {
    position: 'relative',
    height: '100%',
    display: 'flex',
    alignItems: 'flex-end'
  },
  subFooter: {
    borderTop: '1px solid var(--light-gray)',
    padding: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: 'var(--gray-)'
  },
  yearGroup: {
    padding: '8px 16px',
    background: 'rgba(0, 0, 0, .05)',
    borderRadius: '4px'
  },
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '140px'
  },
  spinner: {
    fontSize: '100px',
    color: '#ccc'
  }
})(({ classes, search, filter, onSelect, age }) => {
  const [works, setWorks] = useState(null)

  useEffect(
    () => {
      setWorks(null)
      apiClient
        .get('v3/search.json', {
          params: {
            search_string: search,
            exemplar: filter === 'exemplars' || undefined,
            year_group_id: age === 'all-ages' ? undefined : age,
            limit: '100'
          }
        })
        .then(res => {
          setWorks(res.data.works)
        })
    },
    [search, filter, age]
  )

  return !works ? (
    <div className={classes.loading}>
      <Spinner className={classes.spinner} />
    </div>
  ) : !works.length ? (
    <NoItemsPlaceholder>
      <p>Oops, we couldn't find any works</p>
      <p>
        <Link to={`/works/${filter}/all-ages/`}>Reset filters</Link>
      </p>
    </NoItemsPlaceholder>
  ) : (
    <div className={classes.works}>
      {works &&
        works.map(work => {
          const media = work.media[0]
          const img = media && media.thumb_url
          return (
            <ButtonElement
              onClick={() => onSelect(work)}
              className={classes.work}
              key={work.id}>
              <div className={classes.imgHolder}>
                <Img src={img} alt={work.title} />
              </div>
              <footer>
                <h3>{work.title}</h3>
                <div className={classes.subFooter}>
                  <span>{work.school.country}</span>
                  <span className={classes.yearGroup}>
                    {work.year_group.title}
                  </span>
                </div>
              </footer>
            </ButtonElement>
          )
        })}
    </div>
  )
})

const Works = injectSheet({
  container: {
    '& header': {
      padding: '24px',
      background: '#fff',
      display: 'flex',
      position: 'sticky',
      zIndex: '20',
      top: '-40px',
      boxShadow: '0 0 4px rgb(0 0 0 / 10%)',
      borderRadius: '8px 8px 0 0'
    },
    '& main': {
      padding: '24px',
      background: 'var(--light-gray--)',
      minHeight: '100vh',
      borderRadius: '0 0 8px 8px'
    }
  },
  search: {
    display: 'flex',
    flex: '1',
    maxWidth: '600px',
    '& input': {
      borderRight: 'none',
      borderRadius: '4px 0 0 4px'
    },
    '& button': {
      borderRadius: '0 4px 4px 0'
    }
  },
  headerHolder: {
    maxWidth: '800px',
    margin: 'auto',
    display: 'flex',
    gap: '24px',
    flex: '1'
  },
  toggle: {
    display: 'flex',
    '& button': {
      minWidth: '100px',
      display: 'flex',
      justifyContent: 'center',
      color: 'var(--gray--)',
      borderColor: '#ccc',
      '&:hover': {
        background: 'hsl(224deg 33% 94%)',
        color: 'var(--dark-blue)'
      },
      '&:first-child': {
        borderRadius: '4px 0 0 4px',
        borderRight: 'none'
      },
      '&:last-child': {
        borderRadius: '0 4px 4px 0',
        borderLeft: 'none'
      }
    }
  },
  active: {
    background: 'hsl(225deg 59% 97%)',
    color: 'var(--dark-blue) !important',
    borderColor: 'var(--dark-blue--) !important',
    border: '1px solid var(--dark-blue) !important'
  },
  selectedAge: {
    '& select': {
      background: 'hsl(225deg 59% 97%)',
      borderColor: 'var(--dark-blue) !important',
      color: 'var(--dark-blue)'
    }
  },
  crown: {
    marginRight: '8px',
    color: 'var(--blue)'
  },
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '30vh 0'
  },
  spinner: {
    fontSize: '100px',
    color: '#ccc'
  },
  closeIcon: {
    color: `var(--gray)`,
    background: `var(--light-gray)`,
    width: '24px',
    height: '24px',
    borderRadius: '24px',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: '20px',
    top: '20px',
    '&:hover': {
      border: '1px solid var(--gray--)'
    },
    '&:focus, &:active': {
      background: 'var(--gray)',
      color: 'var(--light-gray)'
    }
  }
})(({ classes, onSelect, requestClose }) => {
  const [upsell, setUpsell] = useState(false)
  const { hasAccessToTL } = useSubscriptionDetails()

  const [controls, setControls] = useState({
    search: '',
    filter: 'all',
    age: 'all-ages'
  })
  const request = useSelector(getCreateSlideRequest)

  const dispatch = useDispatch()

  useEffect(
    () => {
      window.scrollTo({ top: 0 })
    },
    [controls.filter, controls.age]
  )

  return request.pending ? (
    <div className={classes.loading}>
      <Spinner className={classes.spinner} />
    </div>
  ) : (
    <div className={classes.container}>
      <header>
        <ButtonElement
          className={classes.closeIcon}
          onClick={() => {
            dispatch(closeCreateSlideDialog())
          }}>
          <FontAwesomeIcon icon={faTimes} />
        </ButtonElement>
        <div className={classes.headerHolder}>
          <div className={classes.toggle}>
            <Button
              action={() => {
                if (!hasAccessToTL) return setUpsell(true)
                setControls({ ...controls, filter: 'exemplars' })
              }}
              className={`${
                controls.filter === 'exemplars' ? classes.active : ''
              } ${!hasAccessToTL ? 'metrics__exemplars--restricted' : ''}`}
              tall
              secondary>
              {!hasAccessToTL && <SubsCrown className={classes.crown} />}
              Exemplars
            </Button>
            <Button
              action={() => setControls({ ...controls, filter: 'all' })}
              className={controls.filter === 'all' ? classes.active : ''}
              tall
              secondary>
              All work
            </Button>
          </div>
          <FormSelect
            className={controls.age !== 'all-ages' ? classes.selectedAge : ''}
            onChange={e => {
              setControls({ ...controls, age: e.target.value })
            }}
            value={controls.age}>
            <option value="all-ages">All ages</option>
            <option value="983230832">Ages 2-3</option>
            <option value="289203706">Ages 3-4</option>
            <option value="983230830">Ages 4-5</option>
            <option value="831150733">Ages 5-6</option>
            <option value="125366166">Ages 6-7</option>
            <option value="722158882">Ages 7-8</option>
            <option value="675759600">Ages 8-9</option>
            <option value="555429655">Ages 9-10</option>
            <option value="289783040">Ages 10-11</option>
            <option value="749008281">Ages 11-12</option>
            <option value="896117033">Ages 12-13</option>
            <option value="852747123">Ages 13-14</option>
            <option value="182790756">Ages 14-15</option>
            <option value="901756708">Ages 15-16</option>
            <option value="983230831">Ages 16-17</option>
          </FormSelect>
          <form
            onSubmit={e => {
              e.preventDefault()
              setControls({ ...controls, search: e.target.search.value })
            }}
            className={classes.search}>
            <FormInput
              key={controls.search}
              defaultValue={controls.search}
              name="search"
              placeholder="Search..."
            />
            <Button
              type="submit"
              tall
              icon={<FontAwesomeIcon icon={faSearch} />}>
              Search
            </Button>
          </form>
        </div>
      </header>
      <main>
        <WorksGrid
          onSelect={onSelect}
          age={controls.age}
          filter={controls.filter}
          search={controls.search || ''}
        />
        <UpsellModal
          id="exemplars"
          requestClose={() => setUpsell(false)}
          isOpen={upsell}
        />
      </main>
    </div>
  )
})

export const SelectWorkModal = injectSheet({
  content: {
    maxWidth: '1200px',
    padding: '0'
  }
})(({ onSelect, classes }) => {
  const [workPreview, setWorkPreview] = useState({ isOpen: false, work: null })

  const createSlideDialog = useSelector(getCreateSlideDialog)
  const modalOpened =
    createSlideDialog.opened && createSlideDialog.type === 'WorkExemplar'

  return (
    <>
      <Modal isOpen={modalOpened}>
        <ModalContent className={classes.content}>
          <Works onSelect={work => setWorkPreview({ isOpen: true, work })} />
        </ModalContent>
      </Modal>
      <WorkPreviewModal
        isOpen={workPreview.isOpen}
        work={workPreview.work}
        requestClose={() => setWorkPreview({ ...workPreview, isOpen: false })}
      />
    </>
  )
})
